import { render, staticRenderFns } from "./TypesGouvernance.vue?vue&type=template&id=8e60f6a8"
import script from "./TypesGouvernance.vue?vue&type=script&lang=js"
export * from "./TypesGouvernance.vue?vue&type=script&lang=js"
import style0 from "./TypesGouvernance.vue?vue&type=style&index=0&id=8e60f6a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports